var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hidden),expression:"!hidden"}],class:[_vm.prefixCls + '-wrap']},[_c('div',{class:[_vm.prefixCls + '-title']},[_vm._v(_vm._s(_vm.label))]),_c('ul',[_c('li',{ref:"options",class:[_vm.prefixCls]},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }